<template>
    <div class="shadow w-[85%] grow-0 flex items-center bg-[#DCDDDC] rounded-full shadow-[30px] hover:bg-[#CCAF12]">
        <div class="bg-[#ffffff] p-2 rounded-full border-[#016B00] border shadow">
                <DashboardSvg v-show="type === 'dashboard'" />
                <AdminAccount v-show="type === 'adminacc'" />
                <Announcement v-show="type === 'announcement'" />
                <Option v-show="type === 'option'" />
                <Sign v-show="type === 'sign'" />
                <Request v-show="type === 'request'" />
                <Profile v-show="type === 'Profile'" />
                <Payroll v-show="type === 'Payroll'" />
                <Procedures v-show="type === 'Procedures'" />
                <Services v-show="type === 'Services'" />
                
                
        </div>
        <div class="grow text-[#016B00] font-bold pl-3 drop-shadow-md text-xs">
                {{ label }}
        </div>
        <div v-show="dropdown" class="grow-0 pr-6">
                <Dropdown/>
        </div>
    </div>
    </template>
    
    
    <script>
    import { defineComponent } from "vue"
    import DashboardSvg from "./SidebarSvg/DashboardSvg.vue"
    import AdminAccount from "./SidebarSvg/AdminAccountSvg.vue"
    import Announcement from "./SidebarSvg/AnnouncementSvg.vue"
    import Profile from "./SidebarSvg/EmpProfilesvg.vue"
    import Payroll from "./SidebarSvg/EmpPayroll.vue"
    import Procedures from "./SidebarSvg/EmpPolicySvg.vue"
    import Option from "./SidebarSvg/OptionModificationSvg.vue"
    import Request from "./SidebarSvg/RequestSvg.vue"
    import Sign from "./SidebarSvg/SignSvg.vue"
    import Services from "./SidebarSvg//ServicesSvg.vue"
    import Dropdown from "../../icons/DropDownIcon.vue"
    
    
    
    export default defineComponent({
        components: {
            DashboardSvg,
            Dropdown,
            AdminAccount,
            Announcement,
            Option,
            Sign,
            Request,
            Profile,
            Payroll,
            Procedures,
            Services,
        },
      data(){
        return{
            
        }
      },
      props:{
        label:{
            type: String
        },
        dropdown:{
            type: Boolean
        },
        type:{
            type: String
        }
      }
    

    })
    
    </script>
    
    <style scoped>
     .shadow{
        box-shadow: rgba(6, 24, 44, 0.164) 0px 0px 0px 2px, rgba(6, 24, 44, 0.493) 0px 4px 6px -1px, rgba(255, 255, 255, 0.24) 0px 1px 0px inset;
     }
    </style>
    